import React, { useState, useRef, useCallback, useEffect } from 'react';
import './CopyToast.css';

export function CopyToast({ open, message = 'User ID copied to clipboard' }) {
  if (!open) return null;
  return (
    <div className="copy-toast" role="status" aria-live="polite" aria-atomic="true">
      {message}
    </div>
  );
}

export function useCopyToast(durationMs = 2500) {
  const [open, setOpen] = useState(false);
  const timerRef = useRef(null);

  const show = useCallback(() => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
    setOpen(true);
    timerRef.current = window.setTimeout(() => {
      setOpen(false);
      timerRef.current = null;
    }, durationMs);
  }, [durationMs]);

  useEffect(
    () => () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    },
    []
  );

  return { open, show };
}
